"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWifiPaidInHollKzt = function SvgWifiPaidInHollKzt(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wifi-paid-in-holl-kzt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.11 6c-.887 0-1.7.083-2.44.223a2 2 0 1 1-.74-3.931C9.91 2.107 10.97 2 12.11 2c1.126 0 2.17.104 3.134.285a2 2 0 0 1-.738 3.932A12.959 12.959 0 0 0 12.11 6Zm6.22-.78a2 2 0 0 1 2.788-.478 13.035 13.035 0 0 1 1.813 1.54 9.66 9.66 0 0 1 .613.694l.042.055.015.02.006.008.003.003.001.002s.001.001-1.611 1.185l1.612-1.184a2 2 0 0 1-3.215 2.38l-.003-.004a5.678 5.678 0 0 0-.33-.37 9.035 9.035 0 0 0-1.255-1.063 2 2 0 0 1-.479-2.787Zm-12.567.04a2 2 0 0 1-.52 2.78 9.894 9.894 0 0 0-1.318 1.073 6.259 6.259 0 0 0-.356.378l-.005.006A2 2 0 0 1 .428 7.014l.196.155L2 8.25.428 7.014l.002-.003.002-.003L.438 7l.016-.019a4.622 4.622 0 0 1 .183-.214c.116-.131.28-.307.492-.514.422-.413 1.04-.954 1.853-1.512a2 2 0 0 1 2.78.52Zm6.248 16.494c-1.112 0-1.948-.66-1.948-1.993v-4.636h-3.27c-.825 0-1.221-.517-1.221-1.178 0-.693.396-1.222 1.221-1.222h10.425c.825 0 1.221.529 1.221 1.222 0 .66-.396 1.178-1.221 1.178H13.97v4.636c0 1.332-.825 1.993-1.959 1.993Zm-6.44-11.56c0 .66.397 1.177 1.222 1.177h10.425c.825 0 1.221-.517 1.221-1.177 0-.694-.396-1.222-1.221-1.222H6.793c-.825 0-1.221.528-1.221 1.222Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wifi-paid-in-holl-kzt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWifiPaidInHollKzt);
var _default = exports["default"] = Memo;